module.exports = __webpack_public_path__ + "img/bg.5d616f50.jpg";